import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { makeNullable } from '../../utils/typeboxHelpers';
import { sortColumnsSchema } from '../sortColumnsSchema';

export const equipmentPaths = {
    '/api/equipment': {
        get: {
            operationId: 'equipmentControllers.getAll',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                total: Type.Number(),
                                items: Type.Array(
                                    Type.Object({
                                        id: Type.String(),
                                        name: Type.String(),
                                        status: Type.String(),
                                        dateEndCertificateValidity: makeNullable(Type.String()),
                                        dateReminderRecertification: makeNullable(Type.String()),
                                        equipmentType: Type.Object({
                                            name: Type.String(),
                                            isPayload: Type.Boolean(),
                                        }),
                                        clientCompany: Type.Object({
                                            name: Type.String(),
                                        }),
                                    }),
                                ),
                            }),
                        },
                    },
                },
            },
            parameters: [
                { name: 'status', in: 'query', schema: Type.String() },
                { name: 'name', in: 'query', schema: Type.String() },
                { name: 'equipmentTypeId', in: 'query', schema: Type.String() },
                { name: 'clientCompanyId', in: 'query', schema: Type.String() },
                { name: 'expires', in: 'query', schema: Type.String() },
                { name: 'availablePayload', in: 'query', schema: Type.String() },
                { name: 'payload', in: 'query', schema: Type.String() },
                { name: 'limit', in: 'query', schema: Type.String(), required: true },
                { name: 'offset', in: 'query', schema: Type.String(), required: true },
                { name: 'sortColumns', in: 'query', schema: sortColumnsSchema, required: true },
            ],
        },
        post: {
            operationId: 'equipmentControllers.create',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.Optional(Type.String()),
                                name: Type.Optional(Type.String()),
                                clientCompanyId: Type.String(),
                                equipmentTypeId: Type.String(),
                                description: Type.Optional(Type.String()),
                                manufacturer: Type.String(),
                                typeIndication: Type.String(),
                                version: Type.String(),
                                serialNumber: Type.String(),
                                softwareVersion: Type.String(),
                                status: Type.String(),
                                dateInUse: makeNullable(Type.String()),
                                dateOutOfUse: makeNullable(Type.String()),
                                dateStartCertificateValidity: makeNullable(Type.String()),
                                dateEndCertificateValidity: makeNullable(Type.String()),
                                dateReminderRecertification: makeNullable(Type.String()),
                                remarks: Type.String(),
                                created_at: Type.String(),
                                updated_at: Type.String(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            id: Type.Optional(Type.String()),
                            name: Type.Optional(Type.String()),
                            clientCompanyId: Type.String(),
                            equipmentTypeId: Type.String(),
                            description: Type.Optional(Type.String()),
                            manufacturer: Type.String(),
                            typeIndication: Type.String(),
                            version: Type.String(),
                            serialNumber: Type.String(),
                            softwareVersion: Type.String(),
                            status: Type.String(),
                            dateInUse: makeNullable(Type.String()),
                            dateOutOfUse: makeNullable(Type.String()),
                            dateStartCertificateValidity: makeNullable(Type.String()),
                            dateEndCertificateValidity: makeNullable(Type.String()),
                            dateReminderRecertification: makeNullable(Type.String()),
                            remarks: Type.String(),
                            created_at: Type.String(),
                            updated_at: Type.String(),
                        }),
                    },
                },
            },
        },
    },
    '/api/equipmentPayload': {
        get: {
            operationId: 'equipmentControllers.getPayload',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    id: Type.String(),
                                    name: Type.String(),
                                    status: Type.String(),
                                    dateEndCertificateValidity: makeNullable(Type.String()),
                                    dateReminderRecertification: makeNullable(Type.String()),
                                    equipmentType: Type.Object({
                                        name: Type.String(),
                                    }),
                                }),
                            ),
                        },
                    },
                },
            },
            parameters: [{ name: 'equipmentId', in: 'query', schema: Type.String(), required: true }],
        },
        post: {
            operationId: 'equipmentControllers.createPayload',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            equipmentCarrierId: Type.String(),
                            equipmentPartId: Type.String(),
                        }),
                    },
                },
            },
        },
    },
    '/api/equipmentCarrier': {
        get: {
            operationId: 'equipmentControllers.getCarrier',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    equipmentCarrier: Type.Object({
                                        id: Type.String(),
                                        name: Type.String(),
                                        status: Type.String(),
                                        dateEndCertificateValidity: makeNullable(Type.String()),
                                        dateReminderRecertification: makeNullable(Type.String()),
                                    }),
                                }),
                            ),
                        },
                    },
                },
            },
            parameters: [{ name: 'equipmentId', in: 'query', schema: Type.String(), required: true }],
        },
    },
    '/api/equipmentExpirations': {
        get: {
            operationId: 'equipmentControllers.getUpcomingExpirations',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    id: Type.String(),

                                    name: Type.String(),

                                    status: Type.String(),

                                    dateEndCertificateValidity: makeNullable(Type.String()),

                                    dateReminderRecertification: makeNullable(Type.String()),

                                    equipmentType: Type.Object({
                                        name: Type.String(),
                                    }),

                                    clientCompany: Type.Object({
                                        name: Type.String(),
                                    }),
                                }),
                            ),
                        },
                    },
                },
            },
        },
    },
    '/api/equipment/{equipmentId}': {
        parameters: [createPathGuidParameter('equipmentId')],
        get: {
            operationId: 'equipmentControllers.getOne',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Intersect([
                                Type.Object({
                                    description: Type.String(),

                                    partOfEquipmentId: makeNullable(Type.String()),

                                    equipmentTypeId: Type.String(),

                                    clientCompanyId: Type.String(),

                                    name: Type.String(),

                                    manufacturer: Type.String(),

                                    typeIndication: Type.String(),

                                    version: Type.String(),

                                    serialNumber: Type.String(),

                                    softwareVersion: Type.String(),

                                    status: Type.String(),

                                    dateInUse: makeNullable(Type.String()),

                                    dateOutOfUse: makeNullable(Type.String()),

                                    dateStartCertificateValidity: makeNullable(Type.String()),

                                    dateEndCertificateValidity: makeNullable(Type.String()),

                                    dateReminderRecertification: makeNullable(Type.String()),

                                    remarks: Type.String(),

                                    created_at: Type.String(),

                                    updated_at: Type.String(),

                                    equipmentType: Type.Object({
                                        name: Type.String(),
                                        isPayload: Type.Boolean(),
                                        hasLog: Type.Boolean(),
                                    }),

                                    clientCompany: Type.Object({
                                        name: Type.String(),
                                    }),
                                }),
                            ]),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'equipmentControllers.update',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.Optional(Type.String()),
                                name: Type.Optional(Type.String()),
                                clientCompanyId: Type.String(),
                                equipmentTypeId: Type.String(),
                                description: Type.Optional(Type.String()),
                                manufacturer: Type.String(),
                                typeIndication: Type.String(),
                                version: Type.String(),
                                serialNumber: Type.String(),
                                softwareVersion: Type.String(),
                                status: Type.String(),
                                dateInUse: makeNullable(Type.String()),
                                dateOutOfUse: makeNullable(Type.String()),
                                dateStartCertificateValidity: makeNullable(Type.String()),
                                dateEndCertificateValidity: makeNullable(Type.String()),
                                dateReminderRecertification: makeNullable(Type.String()),
                                remarks: Type.String(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            id: Type.Optional(Type.String()),
                            name: Type.Optional(Type.String()),
                            clientCompanyId: Type.String(),
                            equipmentTypeId: Type.String(),
                            description: Type.Optional(Type.String()),
                            manufacturer: Type.String(),
                            typeIndication: Type.String(),
                            version: Type.String(),
                            serialNumber: Type.String(),
                            softwareVersion: Type.String(),
                            status: Type.String(),
                            dateInUse: makeNullable(Type.String()),
                            dateOutOfUse: makeNullable(Type.String()),
                            dateStartCertificateValidity: makeNullable(Type.String()),
                            dateEndCertificateValidity: makeNullable(Type.String()),
                            dateReminderRecertification: makeNullable(Type.String()),
                            remarks: Type.String(),
                            partOfEquipmentId: makeNullable(Type.String()),
                        }),
                    },
                },
            },
        },
        delete: {
            operationId: 'equipmentControllers.remove',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
        },
    },
    '/api/equipmentPayload/{equipmentCarrierId}': {
        parameters: [createPathGuidParameter('equipmentCarrierId')],
        delete: {
            operationId: 'equipmentControllers.removePayload',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
            parameters: [{ name: 'equipmentPartId', in: 'query', schema: Type.String(), required: true }],
        },
    },
} as const;
